export const frontmatter = {"title":"Theme Editor Cn"};
export const toc = [];